import { useState } from 'react'
import Modal from '../Modal'
import { Container } from './styles'
import { GrFormClose } from 'react-icons/gr'
import { useAsyncFn } from 'react-use'
import { useSWRConfig } from 'swr'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { TQuestionBook } from 'pages/Questions/components/QuestionsContent/types'
import { RootState } from 'store/modules/rootReducer'
import Loader from 'assets/icons/loader'
import { COPY_QUESTION_BOOK } from 'pages/MyQuestionBooks/services'

interface IProps {
  questionBook: TQuestionBook
  isOpen: boolean
  onClose(): void
}

const CopyModal = (props: IProps) => {
  const [text, setText] = useState('')
  const { mutate } = useSWRConfig()
  const { token, student } = useSelector((state: RootState) => ({
    token: state.auth.token,
    student: state.student.profile,
  }))

  const [state, post] = useAsyncFn(async () => {
    try {
      const studentBody = {
        _id: student._id,
        name: student.name,
        email: student.email,
      }
      await COPY_QUESTION_BOOK(props.questionBook._id, studentBody, text)

      mutate('/question/books')

      toast.success('Caderno copiado com sucesso!')
    } catch {
      toast.error('Erro ao copiar caderno')
    }
  }, [text, token, student])

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Container>
        <button className="close" onClick={props.onClose}>
          <GrFormClose size="100%" />
        </button>

        <p className="title">Copiar caderno de questões</p>

        <p className="description">
          Defina um nome para realizar a cópia do caderno atual. Caso não queira definir agora, será
          criado como <b>“{props.questionBook.name}(2)”</b>
        </p>

        <div className="input-group">
          <input
            type="text"
            className="text-input"
            placeholder="Nome do caderno"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <button className="save" disabled={state.loading} onClick={post}>
            {state.loading ? <Loader className="loader" /> : 'Criar cópia'}
          </button>
        </div>

        <p className="current-name">
          Nome atual: <b>{props.questionBook.name}</b>
        </p>
      </Container>
    </Modal>
  )
}

export default CopyModal
